<template>
	<progress :class="['dc-progress']" :value="value" :max="max">
		{{ value }}%
	</progress>
</template>

<script>
export default {
	props: {
		value: {
			type: Number,
			default: null
		},
		max: {
			type: Number,
			default: () => 100
		}
	}
};
</script>

<style lang="scss" scoped>
.dc-progress {
	-moz-appearance: none;
	-webkit-appearance: none;
	border: none;
	display: block;
	overflow: hidden;
	width: 100%;
	height: 100%;

	&::-webkit-progress-bar {
		background-color: #dbdbdb;
	}
	&::-webkit-progress-value {
		background-color: #4a4a4a;
	}
	&::-moz-progress-bar {
		background-color: #4a4a4a;
	}
	&::-ms-fill {
		background-color: #4a4a4a;
		border: none;
	}

	&::-webkit-progress-value {
		background-color: #00d1b2;
	}
	&::-moz-progress-bar {
		background-color: #00d1b2;
	}
	&::-ms-fill {
		background-color: #00d1b2;
	}
}
</style>
